export default "__VITE_ASSET__CBcf_r6N__"